import { render, staticRenderFns } from "./PageDiscountsCreate.vue?vue&type=template&id=7ac9bee6&scoped=true&"
import script from "./PageDiscountsCreate.vue?vue&type=script&lang=ts&"
export * from "./PageDiscountsCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageDiscountsCreate.vue?vue&type=style&index=0&id=7ac9bee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9bee6",
  null
  
)

export default component.exports